import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Runs an authenticated API call; on a 401 (expired access token) it refreshes
// the session once and retries, so an open admin page never dies mid-action.
export async function adminCall(fn) {
  try {
    return await fn();
  } catch (err) {
    if (err.response?.status === 401) {
      await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
      return await fn();
    }
    throw err;
  }
}
